<div class="schedule-month">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <button class="btn btn-link px-2" (click)="prevMonth()" aria-label="Mes anterior">
      <i class="fi fi-rr-angle-small-left"></i>
    </button>
    <div class="font-weight-bold text-capitalize">{{ monthLabel() }}</div>
    <button class="btn btn-link px-2" (click)="nextMonth()" aria-label="Mes siguiente">
      <i class="fi fi-rr-angle-small-right"></i> </button>
  </div>

  <div class="grid-7 text-center text-muted small mb-1">
    <div *ngFor="let d of dayNames">{{ d }}</div>
  </div>

  <div class="calendar-grid">
    <div class="week" *ngFor="let week of weeks">
      <ng-container *ngFor="let cell of week">
        <div class="day placeholder" *ngIf="!cell"></div>

        <button *ngIf="cell" type="button" class="day" [class.has-hours]="cell.hasHours"
          [class.no-hours]="!cell.hasHours" [class.selected]="cell.selected" [class.disabled]="isPastDay(cell.date)"
          [disabled]="isPastDay(cell.date)" (click)="selectDate(cell)" [attr.aria-pressed]="cell.selected">
          <span class="num">{{ cell.date.getDate() }}</span>
        </button>

      </ng-container>
    </div>
  </div>
</div>

<!-- Horas del día seleccionado -->
<!-- Horas del día seleccionado -->
<div *ngIf="selectedHours.length > 0" class="mt-4">
  <div class="hour-card mb-2 p-3 rounded" *ngFor="let hour of selectedHours" (click)="selectHour(hour)" [ngClass]="{
      'hour-ondemand': hour.is_ondemand,
      'hour-available': hour.sta_name === 'ACTIVA' && !hour.is_ondemand,
      'hour-confirmed': hour.sta_name === 'CONFIRMADA',
      'hour-selected': selectedHourId === hour.id,
      'hour-disabled': hour.is_ondemand || hour.sta_name !== 'ACTIVA'
    }" [style.cursor]="(hour.is_ondemand || hour.sta_name !== 'ACTIVA') ? 'not-allowed' : 'pointer'">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <strong>
          {{
          hour.sta_name === 'ACTIVA'
          ? (hour.is_ondemand ? 'Atención Inmediata' : 'Hora disponible')
          : ((hour.use_name || '') + ' ' + (hour.use_paternal_surname || '')).trim() || 'Bloque ocupado'
          }}
        </strong>

        <div class=" small">
          {{ hour.sta_name === 'ACTIVA' ? '' : 'Consulta Medicina General' }}
        </div>
      </div>

      <div class="text-right">
        <div>{{ hour.from }} - {{ hour.to }}</div>

        <!-- Badge; no lo muestro para on-demand disponible si ya pintas la card -->
        <span *ngIf="!hour.is_ondemand" class="badge" [ngClass]="{
            'badge-primary': hour.sta_name !== 'ACTIVA',
            'badge-outline-primary': hour.sta_name === 'ACTIVA'
          }">
          {{ hour.sta_name === 'ACTIVA' ? 'Disponible' : hour.sta_name }}
        </span>
      </div>
    </div>
  </div>
</div>


<!-- Sin horas -->
<div *ngIf="selectedHours.length === 0" class="mt-4 text-muted text-center">
  No hay horas disponibles para este día.
</div>